import { X } from 'lucide-react'

interface WelcomeBannerProps {
  source: string | null
  expiryDate: string | null
  onDismiss: () => void
}

export function WelcomeBanner({ source, expiryDate, onDismiss }: WelcomeBannerProps) {
  const formattedExpiry = expiryDate
    ? new Date(expiryDate).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
    : null

  return (
    <div className="border-b border-primary/20 bg-primary/5 px-6 py-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-sm font-semibold text-foreground">
            {source === 'myob_import'
              ? 'Welcome to your imported layout'
              : 'Welcome to the Command Centre'}
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {source === 'myob_import'
              ? "Your MYOB data has been imported and the classic Command Centre layout is active. Everything works the same way you're used to, backed by the modern Ledger Core engine."
              : "You've activated the Command Centre layout. Navigate using the familiar tab bar and flowchart panels."}
          </p>
          {formattedExpiry && (
            <p className="mt-1 text-xs text-muted-foreground">
              This layout is available until {formattedExpiry}. After that date, the modern interface will be used permanently.
            </p>
          )}
        </div>
        <button
          onClick={onDismiss}
          className="mt-0.5 rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
          aria-label="Dismiss welcome banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
